import { __awaiter, __generator } from 'tslib';
import { getLoginUrl, LOGIN_TYPE, subscribeOnLoginSuccess, subscribeOnLoginFailure } from '@sravni/utils/lib/auth';

var ESIA_STATE = {
    Window: null,
};
var ESIA_ERRORS = {
    AUTH_ERROR: 'AUTH_ERROR',
    OPEN_WINDOW_ERROR: 'OPEN_WINDOW_ERROR',
};
var tryWindowLogin = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve, reject) {
                subscribeOnLoginSuccess(function () {
                    var _a;
                    (_a = ESIA_STATE.Window) === null || _a === void 0 ? void 0 : _a.close();
                    resolve();
                });
                subscribeOnLoginFailure(function () {
                    setTimeout(function () {
                        var _a;
                        (_a = ESIA_STATE.Window) === null || _a === void 0 ? void 0 : _a.close();
                        reject(new Error(ESIA_ERRORS.AUTH_ERROR));
                    });
                });
                setTimeout(function () {
                    ESIA_STATE.Window = window.open(url, '_blank');
                    if (!ESIA_STATE.Window) {
                        reject(new Error(ESIA_ERRORS.OPEN_WINDOW_ERROR));
                    }
                }, 0);
            })];
    });
}); };
var tryDirectLogin = function (url) { return (window.location.href = url); };
var tryEsiaLogin = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var returnUrl, onSuccess, onError, url, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                returnUrl = params.returnUrl, onSuccess = params.onSuccess, onError = params.onError;
                url = getLoginUrl({
                    returnUrl: returnUrl,
                    loginType: LOGIN_TYPE.ESIA,
                    isNewWindow: true,
                });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, tryWindowLogin(url)];
            case 2:
                _a.sent();
                return [3 /*break*/, 4];
            case 3:
                error_1 = _a.sent();
                if (onError) {
                    onError(error_1);
                }
                if (error_1.message === ESIA_ERRORS.OPEN_WINDOW_ERROR) {
                    tryDirectLogin(url);
                }
                return [2 /*return*/];
            case 4:
                if (onSuccess) {
                    return [2 /*return*/, onSuccess()];
                }
                return [2 /*return*/];
        }
    });
}); };

export { tryEsiaLogin };
//# sourceMappingURL=esia.login.js.map
